<template>
	<div class="notifications-alert" v-show="notifications.length > 0">
		<Alert
			v-for="notification in notifications"
			:key="notification.id"
			:type="notification.type"
			:title="notification.title"
			:message="notification.message"
			:id="notification.id"
		/>
	</div>
</template>

<script>
export default {
	components:{
		Alert: () => import('./alert')
	},
	created() {
		//Logic to push the most recent notification to the top of the notifications
		Event.$on("notifications:show", async payload => {
			let id = Math.round(Math.random() * 10000000);

			payload.id = id;
			if (payload.message.length > 0 && !this.isMessageDisplayed(payload.message)) {
				this.notifications.push(payload);
				await utils.sleep(payload.duration || 50);
				this.closeNotification(id)
			}
		});

		Event.$on("notification:close", payload => {
			this.closeNotification(payload.id)
		});
	},
	data() {
		return {
			notifications: []
		};
	},
	methods: {
		isMessageDisplayed(message){
			if(this.notifications.length > 0 && this.notifications[this.notifications.length-1].message === message){
				return true
			}else{
				return false
			}
		},
		closeNotification(id) {
			for (let i = 0; i < this.notifications.length; i++) {
				const notification = this.notifications[i];

				if(notification.id === id){
					this.notifications.splice(i, 1);
					break;
				}
			}
		}
	}
};
</script>

<style lang="scss">
// TODO Fix notification scrolling capability

@media(max-width: $breakpoint-sm){
   .notifications-alert {
		width: 100vw !important;
	}
}

.notifications-alert {
	position: fixed;
	right: 15px;
	top: 20px;
	z-index: 2500;
	width: 450px;
	max-height: 98vh;
}
</style>